import React from "react";

export default function SpinnerThree() {
  return (
    <div className="flex items-center justify-center gap-4 sm:justify-normal">
      <div className="animate-spin">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26357)">
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.56567 1.89572C7.45878 1.92545 7.35435 1.96002 7.24873 1.99825C6.84803 2.13403 6.41155 1.92214 6.27211 1.52025C6.13268 1.11835 6.34822 0.683069 6.75012 0.543632C6.87396 0.49923 6.9966 0.458483 7.1217 0.422589C7.52976 0.301364 7.9566 0.530334 8.08267 0.935943C8.2039 1.34401 7.97373 1.7745 7.56567 1.89572Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1891 1.53754C10.076 1.53688 9.96773 1.53377 9.85707 1.53797C9.43384 1.54494 9.08309 1.20734 9.07366 0.779262C9.06669 0.356033 9.40794 0.00648122 9.83117 -0.000488606C9.9613 -0.00235203 10.0914 -0.00421531 10.224 -0.00122585C10.6498 0.00881969 10.9836 0.361096 10.9735 0.786842C10.9671 1.21379 10.6149 1.54758 10.1891 1.53754Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.7721 1.53914C13.6318 1.94242 13.1938 2.15502 12.7917 2.01106L12.4774 1.90803C12.0681 1.786 11.841 1.35535 11.9666 0.947277C12.0911 0.542854 12.5181 0.314503 12.9262 0.440183C12.9895 0.456896 13.0517 0.477264 13.1138 0.497631C13.1759 0.517999 13.2381 0.538367 13.299 0.562389C13.7023 0.702688 13.9112 1.13951 13.7721 1.53914Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.2065 3.11798C15.9455 3.4574 15.4629 3.52183 15.126 3.26566C15.0393 3.19676 14.9502 3.13517 14.8586 3.06873C14.5096 2.82478 14.4233 2.34721 14.6709 1.99934C14.9148 1.65028 15.3924 1.56398 15.7415 1.80793C15.8501 1.88401 15.9539 1.96256 16.0576 2.0411C16.3946 2.29727 16.4627 2.78101 16.2065 3.11798Z"
              fill="#465FFF"
            />
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0255 5.37374C17.6751 5.61509 17.1979 5.52746 16.9554 5.18081C16.8929 5.08747 16.8292 4.99778 16.7607 4.91055C16.5035 4.57127 16.5729 4.08806 16.9122 3.83096C17.2539 3.5787 17.7335 3.64686 17.9906 3.98614C18.0701 4.08913 18.1449 4.19457 18.2184 4.30367C18.4597 4.65398 18.3758 5.13239 18.0255 5.37374Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.0632 8.08202C18.6552 8.20324 18.2247 7.97307 18.1035 7.56501C18.0725 7.46178 18.0392 7.3537 18.0009 7.24807C17.8652 6.84737 18.077 6.41089 18.4789 6.27146C18.8808 6.13202 19.3161 6.34757 19.4556 6.74946C19.5 6.8733 19.5407 6.99594 19.5766 7.12104C19.6978 7.52911 19.4689 7.95594 19.0632 8.08202Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.2105 10.9759C18.7884 10.9671 18.451 10.6136 18.461 10.1879C18.4605 10.0784 18.4648 9.96649 18.4606 9.85583C18.4536 9.4326 18.7912 9.08185 19.2181 9.07608C19.6425 9.06545 19.9921 9.4067 19.999 9.82993C20.0009 9.96006 20.0027 10.0902 19.9998 10.2228C19.9897 10.6485 19.6362 10.986 19.2105 10.9759Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.5633 12.9287L19.441 13.3015C19.2971 13.7036 18.8603 13.9125 18.4606 13.7734C18.0574 13.6331 17.8448 13.1951 17.9887 12.793L18.0918 12.4787C18.2138 12.0694 18.6444 11.8423 19.0525 11.968C19.4569 12.0924 19.6853 12.5194 19.5633 12.9287Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.1909 15.7417C18.1149 15.8503 18.0363 15.9541 17.9578 16.0578C17.7004 16.3985 17.2179 16.4629 16.8809 16.2067C16.5415 15.9457 16.477 15.4631 16.7332 15.1262C16.8021 15.0395 16.8637 14.9504 16.9301 14.8588C17.1741 14.5098 17.6541 14.4283 17.9995 14.6711C18.3486 14.915 18.4349 15.3926 18.1909 15.7417Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.014 17.9904C15.911 18.07 15.8056 18.1447 15.6965 18.2182C15.345 18.4632 14.8678 18.3756 14.6264 18.0253C14.3851 17.675 14.4727 17.1978 14.8194 16.9552C14.9127 16.8927 15.0024 16.829 15.0896 16.7605C15.4289 16.5034 15.9121 16.5727 16.1692 16.912C16.4215 17.2538 16.3533 17.7333 16.014 17.9904Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.2507 19.4561C13.1268 19.5005 13.0042 19.5412 12.8791 19.5771C12.471 19.6984 12.0442 19.4694 11.9181 19.0638C11.7969 18.6557 12.0271 18.2252 12.4351 18.104C12.542 18.0743 12.6464 18.0397 12.7521 18.0015C13.1528 17.8657 13.5893 18.0776 13.7287 18.4795C13.8681 18.8814 13.6526 19.3166 13.2507 19.4561Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1714 20.0005C10.0413 20.0024 9.91118 20.0042 9.77859 20.0013C9.35284 19.9912 9.01904 19.6389 9.02909 19.2132C9.03428 18.7899 9.38776 18.4524 9.8135 18.4625C9.92542 18.4668 10.0349 18.4663 10.1455 18.4621C10.5688 18.4551 10.9195 18.7927 10.929 19.2208C10.9359 19.644 10.5947 19.9935 10.1714 20.0005Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.03166 19.053C7.90718 19.4574 7.48018 19.6858 7.07091 19.5637L6.69812 19.4415C6.29603 19.2976 6.08709 18.8608 6.22619 18.4611C6.36649 18.0578 6.80331 17.8489 7.2066 17.9892L7.52091 18.0922C7.92899 18.2179 8.15734 18.6449 8.03166 19.053Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.32784 18.0007C5.08389 18.3498 4.60632 18.436 4.25726 18.1921C4.14863 18.116 4.04485 18.0375 3.94108 17.9589C3.60411 17.7028 3.53603 17.219 3.7922 16.882C4.05323 16.5426 4.53577 16.4782 4.87274 16.7344C4.95944 16.8033 5.04733 16.8685 5.14008 16.9313C5.48915 17.1752 5.57425 17.6565 5.32784 18.0007Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.08862 16.1693C2.74688 16.4215 2.26733 16.3533 2.01023 16.0141C1.93066 15.9111 1.85594 15.8056 1.78242 15.6965C1.54107 15.3462 1.62505 14.8678 1.97535 14.6265C2.32565 14.3851 2.80287 14.4728 3.04542 14.8194C3.10791 14.9127 3.1716 15.0024 3.24015 15.0897C3.49725 15.4289 3.4279 15.9121 3.08862 16.1693Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.51971 13.7285C1.11782 13.868 0.681338 13.6561 0.543098 13.2505C0.498696 13.1267 0.457949 13.004 0.422055 12.8789C0.300831 12.4709 0.5298 12.044 0.935409 11.918C1.34348 11.7967 1.77397 12.0269 1.89519 12.435C1.92491 12.5419 1.95949 12.6463 1.99772 12.7519C2.1335 13.1526 1.92161 13.5891 1.51971 13.7285Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.780544 10.9277C0.357315 10.9347 0.00656488 10.5971 0.000793115 10.1702C-0.00107028 10.0401 -0.00293353 9.90992 5.59077e-05 9.77733C0.0101014 9.35158 0.362378 9.01779 0.788124 9.02783C1.21022 9.03668 1.54886 9.3865 1.53882 9.81225C1.53816 9.92536 1.53505 10.0336 1.53925 10.1443C1.54622 10.5675 1.20863 10.9183 0.780544 10.9277Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.1793 3.04476C5.08596 3.10725 4.99507 3.1746 4.90904 3.23949C4.56976 3.4966 4.08655 3.42724 3.82945 3.08796C3.57719 2.74623 3.64535 2.26667 3.98463 2.00957C4.08762 1.93 4.19306 1.85528 4.30216 1.78176C4.65247 1.54041 5.13088 1.62439 5.37223 1.97469C5.61358 2.325 5.52595 2.80221 5.1793 3.04476Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.01043 7.20687L1.90739 7.52118C1.78537 7.93046 1.35472 8.15761 0.946643 8.03193C0.54222 7.90745 0.31387 7.48046 0.435894 7.07118L0.558101 6.69839C0.702054 6.29631 1.13887 6.08737 1.5385 6.22647C1.94179 6.36677 2.15438 6.80479 2.01043 7.20687Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.2666 4.87394C3.19771 4.96064 3.13492 5.05339 3.06968 5.14128C2.82573 5.49035 2.34451 5.57545 1.99909 5.3327C1.65002 5.08875 1.56492 4.60753 1.80888 4.25846C1.88496 4.14983 1.9635 4.04606 2.04205 3.94228C2.29822 3.60532 2.78196 3.53723 3.11773 3.79706C3.45835 4.05443 3.52278 4.53698 3.2666 4.87394Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26357">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26379)">
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.5912 2.65401C10.4415 2.69562 10.2953 2.74403 10.1474 2.79755C9.58646 2.98765 8.97539 2.69099 8.78018 2.12834C8.58496 1.56569 8.88673 0.956297 9.44938 0.761084C9.62276 0.698922 9.79446 0.641876 9.96959 0.591624C10.5409 0.42191 11.1385 0.742467 11.315 1.31032C11.4847 1.88161 11.1624 2.4843 10.5912 2.65401Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.264 2.15226C14.1056 2.15134 13.954 2.14699 13.7991 2.15287C13.2066 2.16263 12.7155 1.68999 12.7023 1.09067C12.6926 0.498154 13.1703 0.00878077 13.7629 -0.000977002C13.945 -0.00358581 14.1272 -0.00619443 14.3129 -0.00200915C14.9089 0.0120545 15.3762 0.505241 15.3621 1.10129C15.3532 1.69901 14.86 2.16632 14.264 2.15226Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.2833 2.1547C19.0869 2.71929 18.4737 3.01693 17.9107 2.81539L17.4707 2.67114C16.8977 2.50031 16.5797 1.8974 16.7557 1.32609C16.9299 0.759898 17.5277 0.440207 18.099 0.616159C18.1877 0.639557 18.2747 0.668071 18.3617 0.696586C18.4486 0.725101 18.5356 0.753616 18.6209 0.787247C19.1855 0.983666 19.478 1.59521 19.2833 2.1547Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.6875 4.36517C22.3221 4.84036 21.6465 4.93056 21.1748 4.57192C21.0534 4.47546 20.9287 4.38924 20.8005 4.29623C20.3118 3.95469 20.191 3.2861 20.5376 2.79908C20.8792 2.31039 21.5478 2.18957 22.0365 2.5311C22.1885 2.63762 22.3338 2.74758 22.4791 2.85754C22.9509 3.21618 23.0462 3.89342 22.6875 4.36517Z"
              fill="#465FFF"
            />
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.2364 7.52284C24.746 7.86073 24.0779 7.73805 23.7383 7.25274C23.6508 7.12206 23.5617 6.9965 23.4657 6.87438C23.1057 6.39939 23.2029 5.7229 23.6778 5.36295C24.1563 5.0098 24.8276 5.10522 25.1876 5.58021C25.299 5.72439 25.4036 5.87201 25.5065 6.02475C25.8444 6.51518 25.7268 7.18496 25.2364 7.52284Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.6901 11.3146C26.1188 11.4843 25.5161 11.1621 25.3464 10.5908C25.3031 10.4463 25.2564 10.295 25.2029 10.1471C25.0128 9.58613 25.3094 8.97506 25.8721 8.77984C26.4347 8.58463 27.0441 8.8864 27.2393 9.44905C27.3015 9.62243 27.3585 9.79412 27.4088 9.96926C27.5785 10.5406 27.258 11.1381 26.6901 11.3146Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.8955 15.3661C26.3045 15.3537 25.8321 14.8589 25.8462 14.2628C25.8454 14.1096 25.8514 13.9529 25.8456 13.798C25.8358 13.2054 26.3084 12.7144 26.9061 12.7063C27.5003 12.6914 27.9897 13.1692 27.9994 13.7617C28.002 13.9439 28.0046 14.1261 28.0004 14.3117C27.9864 14.9078 27.4915 15.3802 26.8955 15.3661Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.3901 18.1004L27.219 18.6223C27.0175 19.1852 26.4059 19.4777 25.8465 19.283C25.2819 19.0866 24.9842 18.4733 25.1858 17.9104L25.33 17.4704C25.5009 16.8974 26.1038 16.5794 26.6751 16.7553C27.2413 16.9296 27.561 17.5274 27.3901 18.1004Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.4681 22.0379C25.3616 22.19 25.2516 22.3353 25.1417 22.4806C24.7813 22.9574 24.1058 23.0476 23.634 22.689C23.1588 22.3236 23.0686 21.648 23.4273 21.1763C23.5237 21.0549 23.61 20.9301 23.703 20.802C24.0445 20.3133 24.7165 20.1993 25.2001 20.5391C25.6888 20.8806 25.8096 21.5492 25.4681 22.0379Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.4212 25.1863C22.277 25.2977 22.1294 25.4023 21.9766 25.5052C21.4845 25.8482 20.8164 25.7255 20.4786 25.2351C20.1407 24.7447 20.2634 24.0766 20.7487 23.737C20.8793 23.6495 21.0049 23.5603 21.127 23.4644C21.602 23.1044 22.2785 23.2015 22.6385 23.6765C22.9916 24.155 22.8962 24.8263 22.4212 25.1863Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.5494 27.2387C18.376 27.3009 18.2043 27.3579 18.0292 27.4082C17.4579 27.5779 16.8603 27.2573 16.6838 26.6895C16.5141 26.1182 16.8363 25.5155 17.4076 25.3458C17.5573 25.3042 17.7035 25.2558 17.8513 25.2023C18.4123 25.0122 19.0234 25.3088 19.2186 25.8715C19.4138 26.4341 19.112 27.0435 18.5494 27.2387Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.2385 28.0006C14.0563 28.0032 13.8741 28.0058 13.6885 28.0017C13.0924 27.9876 12.6251 27.4944 12.6392 26.8984C12.6464 26.3058 13.1413 25.8333 13.7373 25.8474C13.894 25.8534 14.0473 25.8527 14.2022 25.8468C14.7947 25.837 15.2858 26.3097 15.299 26.909C15.3087 27.5015 14.831 27.9909 14.2385 28.0006Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.2459 26.674C11.0716 27.2402 10.4738 27.5599 9.90083 27.389L9.37893 27.218C8.81601 27.0164 8.52349 26.4049 8.71823 25.8454C8.91465 25.2808 9.5262 24.9883 10.0908 25.1847L10.5308 25.3289C11.1021 25.5049 11.4218 26.1027 11.2459 26.674Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.45976 25.2011C7.11823 25.6897 6.44963 25.8106 5.96094 25.469C5.80886 25.3625 5.66358 25.2526 5.51829 25.1426C5.04654 24.784 4.95122 24.1067 5.30987 23.635C5.67531 23.1598 6.35086 23.0696 6.82262 23.4282C6.94399 23.5247 7.06705 23.616 7.1969 23.7039C7.68559 24.0454 7.80473 24.7192 7.45976 25.2011Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.32485 22.6369C3.84642 22.99 3.17504 22.8946 2.8151 22.4196C2.7037 22.2754 2.5991 22.1278 2.49617 21.975C2.15828 21.4846 2.27585 20.8148 2.76627 20.477C3.2567 20.1391 3.9248 20.2618 4.26437 20.7471C4.35186 20.8777 4.44103 21.0033 4.53699 21.1254C4.89694 21.6004 4.79984 22.2769 4.32485 22.6369Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.12994 19.2202C1.56729 19.4154 0.956217 19.1188 0.762681 18.551C0.700519 18.3776 0.643473 18.2059 0.593221 18.0308C0.423507 17.4595 0.744064 16.8619 1.31192 16.6854C1.88321 16.5157 2.48589 16.838 2.65561 17.4092C2.69722 17.5589 2.74563 17.7051 2.79915 17.853C2.98924 18.4139 2.69259 19.025 2.12994 19.2202Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.0912 15.2985C0.498679 15.3082 0.00762832 14.8356 -0.000452107 14.238C-0.0030609 14.0558 -0.00566948 13.8736 -0.00148424 13.688C0.0125795 13.0919 0.505766 12.6246 1.10181 12.6387C1.69274 12.6511 2.16685 13.1408 2.15278 13.7369C2.15187 13.8952 2.14751 14.0468 2.15339 14.2017C2.16315 14.7942 1.69051 15.2853 1.0912 15.2985Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.25336 4.26305C7.12268 4.35055 6.99544 4.44483 6.875 4.53568C6.40001 4.89563 5.72352 4.79853 5.36357 4.32354C5.01042 3.84511 5.10584 3.17373 5.58083 2.81379C5.72501 2.70239 5.87263 2.59778 6.02537 2.49486C6.5158 2.15697 7.18558 2.27454 7.52346 2.76496C7.86135 3.25539 7.73867 3.92349 7.25336 4.26305Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.81382 10.0899L2.66957 10.53C2.49873 11.1029 1.89583 11.421 1.32452 11.245C0.758327 11.0707 0.438636 10.4729 0.609471 9.89995L0.78056 9.37805C0.982095 8.81512 1.59364 8.52261 2.15313 8.71735C2.71772 8.91377 3.01536 9.52699 2.81382 10.0899Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.57168 6.82391C4.47523 6.94529 4.38733 7.07513 4.29599 7.19819C3.95446 7.68688 3.28075 7.80602 2.79717 7.46617C2.30847 7.12464 2.18933 6.45093 2.53086 5.96223C2.63738 5.81015 2.74734 5.66487 2.8573 5.51959C3.21595 5.04783 3.89318 4.95251 4.36326 5.31628C4.84013 5.6766 4.93033 6.35216 4.57168 6.82391Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26379">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26401)">
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.6166 3.41279C13.4242 3.46629 13.2363 3.52852 13.0461 3.59734C12.3249 3.84175 11.5392 3.46034 11.2882 2.73693C11.0373 2.01352 11.4252 1.23001 12.1487 0.979025C12.3716 0.899102 12.5923 0.825757 12.8175 0.761148C13.552 0.542944 14.3203 0.955089 14.5473 1.68519C14.7655 2.4197 14.3512 3.19459 13.6166 3.41279Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.3388 2.76747C18.1352 2.76629 17.9403 2.76069 17.7412 2.76825C16.9793 2.7808 16.348 2.17312 16.331 1.40257C16.3185 0.640762 16.9327 0.0115686 17.6945 -0.000977146C17.9288 -0.00433133 18.163 -0.00768522 18.4017 -0.00230421C19.168 0.0157776 19.7689 0.649875 19.7508 1.41622C19.7393 2.18472 19.1052 2.78555 18.3388 2.76747Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.7906 2.77025C24.538 3.49617 23.7496 3.87884 23.0259 3.61972L22.4601 3.43425C21.7234 3.21461 21.3145 2.43944 21.5407 1.7049C21.7648 0.976942 22.5334 0.565911 23.2679 0.792134C23.3819 0.822217 23.4938 0.858879 23.6056 0.895541C23.7174 0.932203 23.8293 0.968865 23.939 1.01211C24.6649 1.26464 25.041 2.05092 24.7906 2.77025Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.1725 5.61236C28.7026 6.22332 27.8341 6.33929 27.2275 5.87818C27.0715 5.75417 26.9111 5.64331 26.7463 5.52372C26.118 5.0846 25.9626 4.22498 26.4083 3.59882C26.8474 2.9705 27.7071 2.81516 28.3354 3.25427C28.5309 3.39123 28.7177 3.5326 28.9045 3.67398C29.511 4.13509 29.6336 5.00582 29.1725 5.61236Z"
              fill="#465FFF"
            />
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.4435 9.67244C31.8129 10.1069 30.9539 9.94913 30.5173 9.32516C30.4049 9.15715 30.2902 8.99571 30.1668 8.83869C29.704 8.22799 29.8289 7.35822 30.4396 6.89543C31.0547 6.44138 31.9179 6.56406 32.3807 7.17476C32.5239 7.36014 32.6584 7.54994 32.7907 7.74632C33.2252 8.37687 33.074 9.23801 32.4435 9.67244Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.317 14.5472C33.5824 14.7654 32.8076 14.3511 32.5894 13.6166C32.5337 13.4308 32.4736 13.2363 32.4048 13.0461C32.1604 12.3249 32.5418 11.5392 33.2652 11.2882C33.9886 11.0372 34.7721 11.4252 35.0231 12.1486C35.103 12.3715 35.1764 12.5923 35.241 12.8175C35.4592 13.552 35.0471 14.3203 34.317 14.5472Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.5804 19.7568C33.8207 19.7409 33.2133 19.1046 33.2314 18.3383C33.2304 18.1412 33.2381 17.9398 33.2306 17.7406C33.218 16.9788 33.8257 16.3474 34.5941 16.337C35.3581 16.3179 35.9873 16.9322 35.9998 17.694C36.0032 17.9282 36.0065 18.1625 36.0011 18.4011C35.983 19.1675 35.3468 19.7749 34.5804 19.7568Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.2131 23.2716L34.9931 23.9426C34.734 24.6663 33.9477 25.0424 33.2284 24.792C32.5025 24.5395 32.1198 23.7511 32.3789 23.0273L32.5644 22.4616C32.784 21.7249 33.5592 21.316 34.2937 21.5422C35.0217 21.7663 35.4327 22.5349 35.2131 23.2716Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7452 28.3347C32.6083 28.5302 32.4669 28.717 32.3255 28.9038C31.8623 29.5169 30.9937 29.6329 30.3872 29.1718C29.7762 28.7019 29.6602 27.8334 30.1213 27.2268C30.2454 27.0708 30.3562 26.9104 30.4758 26.7456C30.9149 26.1173 31.779 25.9707 32.4007 26.4076C33.029 26.8467 33.1844 27.7064 32.7452 28.3347Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.8245 32.3826C28.6391 32.5259 28.4493 32.6604 28.2529 32.7927C27.6202 33.2337 26.7612 33.076 26.3268 32.4454C25.8924 31.8149 26.0501 30.9559 26.6741 30.5193C26.8421 30.4068 27.0035 30.2922 27.1605 30.1688C27.7712 29.706 28.641 29.8308 29.1038 30.4415C29.5578 31.0567 29.4352 31.9198 28.8245 32.3826Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.852 35.0213C23.6291 35.1013 23.4083 35.1746 23.1832 35.2392C22.4487 35.4574 21.6804 35.0453 21.4534 34.3152C21.2352 33.5807 21.6495 32.8058 22.384 32.5876C22.5764 32.5341 22.7644 32.4718 22.9545 32.403C23.6758 32.1586 24.4614 32.54 24.7124 33.2634C24.9634 33.9869 24.5754 34.7704 23.852 35.0213Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.3055 36.0012C18.0712 36.0046 17.837 36.0079 17.5983 36.0025C16.832 35.9845 16.2312 35.3504 16.2492 34.584C16.2586 33.8221 16.8948 33.2147 17.6612 33.2328C17.8626 33.2405 18.0597 33.2395 18.2589 33.232C19.0207 33.2194 19.652 33.8271 19.669 34.5977C19.6815 35.3595 19.0673 35.9887 18.3055 36.0012Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.4562 34.295C14.2321 35.023 13.4635 35.434 12.7269 35.2143L12.0558 34.9944C11.3321 34.7353 10.956 33.949 11.2064 33.2296C11.4589 32.5037 12.2452 32.1276 12.9711 32.3802L13.5369 32.5656C14.2714 32.7919 14.6824 33.5605 14.4562 34.295Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.59168 32.4014C9.15257 33.0297 8.29294 33.1851 7.66462 32.746C7.46909 32.609 7.2823 32.4676 7.09551 32.3263C6.48897 31.8652 6.36642 30.9944 6.82753 30.3879C7.29738 29.7769 8.16595 29.6609 8.77249 30.1221C8.92855 30.2461 9.08676 30.3635 9.25371 30.4765C9.88203 30.9156 10.0352 31.7818 9.59168 32.4014Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.55717 29.1045C4.94205 29.5585 4.07885 29.4358 3.61606 28.8251C3.47284 28.6397 3.33835 28.4499 3.20601 28.2536C2.77159 27.623 2.92274 26.7619 3.55329 26.3274C4.18383 25.893 5.04282 26.0508 5.47941 26.6747C5.5919 26.8427 5.70654 27.0042 5.82992 27.1612C6.29271 27.7719 6.16787 28.6417 5.55717 29.1045Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.73626 24.7114C2.01285 24.9624 1.22719 24.581 0.978358 23.851C0.898435 23.6281 0.82509 23.4074 0.760481 23.1822C0.542277 22.4477 0.954422 21.6794 1.68452 21.4524C2.41904 21.2342 3.19392 21.6485 3.41212 22.383C3.46562 22.5754 3.52786 22.7634 3.59667 22.9535C3.84108 23.6748 3.45967 24.4604 2.73626 24.7114Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.40185 19.6697C0.640042 19.6823 0.00869176 19.0746 -0.00169732 18.3062C-0.00505154 18.072 -0.00840535 17.8378 -0.00302438 17.5991C0.0150575 16.8328 0.649155 16.2319 1.4155 16.25C2.17526 16.2659 2.78483 16.8956 2.76675 17.6619C2.76557 17.8656 2.75997 18.0604 2.76753 18.2596C2.78008 19.0214 2.1724 19.6528 1.40185 19.6697Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.32352 5.48086C9.1555 5.59335 8.99191 5.71457 8.83705 5.83138C8.22635 6.29417 7.35658 6.16932 6.89379 5.55862C6.43973 4.9435 6.56242 4.08031 7.17312 3.61752C7.3585 3.47429 7.5483 3.3398 7.74468 3.20747C8.37522 2.77304 9.23637 2.9242 9.67079 3.55474C10.1052 4.18529 9.94749 5.04428 9.32352 5.48086Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.62112 12.9725L3.43565 13.5382C3.21601 14.2749 2.44084 14.6838 1.7063 14.4576C0.97834 14.2335 0.567309 13.4649 0.786954 12.7282L1.00693 12.0572C1.26604 11.3335 2.05232 10.9574 2.77165 11.2077C3.49756 11.4603 3.88023 12.2487 3.62112 12.9725Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.87676 8.77339C5.75275 8.92944 5.63973 9.09639 5.5223 9.25461C5.08319 9.88293 4.21699 10.0361 3.59524 9.59915C2.96692 9.16004 2.81374 8.29384 3.25285 7.66552C3.38981 7.46999 3.53118 7.28319 3.67256 7.0964C4.13367 6.48986 5.0044 6.36731 5.60878 6.835C6.2219 7.29827 6.33788 8.16685 5.87676 8.77339Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26401">
              <rect width="36" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26423)">
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.1313 3.79193C14.9176 3.85138 14.7087 3.92053 14.4975 3.99699C13.6961 4.26855 12.8231 3.84477 12.5442 3.04098C12.2654 2.23719 12.6964 1.36663 13.5002 1.08775C13.7479 0.998948 13.9932 0.917454 14.2434 0.845666C15.0595 0.603217 15.9132 1.06116 16.1653 1.87237C16.4078 2.68851 15.9475 3.54949 15.1313 3.79193Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.3743 3.07507C20.1481 3.07377 19.9315 3.06754 19.7102 3.07594C18.8638 3.08988 18.1623 2.41469 18.1434 1.55852C18.1295 0.712066 18.812 0.0129624 19.6584 -0.000977211C19.9187 -0.00470407 20.179 -0.00843062 20.4441 -0.0024517C21.2956 0.0176394 21.9632 0.722192 21.9431 1.57368C21.9304 2.42757 21.2258 3.09516 20.3743 3.07507Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.5481 3.07828C27.2675 3.88485 26.3915 4.31003 25.5873 4.02213L24.9587 3.81605C24.1401 3.572 23.6858 2.71071 23.9372 1.89455C24.1862 1.08571 25.0402 0.629007 25.8563 0.880366C25.983 0.913792 26.1072 0.954527 26.2315 0.995263C26.3558 1.036 26.48 1.07673 26.6019 1.12478C27.4085 1.40538 27.8263 2.27902 27.5481 3.07828Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.413 6.23547C31.8909 6.91431 30.9259 7.04317 30.2519 6.53082C30.0785 6.39303 29.9003 6.26986 29.7172 6.13698C29.0191 5.64907 28.8465 4.69394 29.3417 3.9982C29.8296 3.30006 30.7848 3.12747 31.4829 3.61537C31.7002 3.76754 31.9077 3.92462 32.1153 4.08171C32.7892 4.59406 32.9254 5.56153 32.413 6.23547Z"
              fill="#465FFF"
            />
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.0509 10.747C35.3503 11.2297 34.3959 11.0544 33.9108 10.3611C33.7858 10.1744 33.6584 9.99507 33.5213 9.82061C33.0071 9.14205 33.1458 8.17564 33.8244 7.66143C34.5078 7.15692 35.4669 7.29324 35.9812 7.9718C36.1403 8.17777 36.2897 8.38866 36.4368 8.60686C36.9195 9.30747 36.7515 10.2643 36.0509 10.747Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.1265 16.1635C37.3104 16.406 36.4494 15.9457 36.2069 15.1295C36.1451 14.9231 36.0783 14.7069 36.0019 14.4957C35.7303 13.6943 36.1541 12.8213 36.9579 12.5424C37.7617 12.2635 38.6322 12.6946 38.9111 13.4984C38.9999 13.7461 39.0814 13.9914 39.1532 14.2416C39.3956 15.0577 38.9377 15.9114 38.1265 16.1635Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.4249 21.9519C37.5807 21.9342 36.9058 21.2272 36.9259 20.3757C36.9248 20.1568 36.9334 19.933 36.925 19.7117C36.9111 18.8652 37.5863 18.1637 38.44 18.1522C39.2889 18.1309 39.988 18.8134 40.0019 19.6599C40.0057 19.9201 40.0094 20.1804 40.0034 20.4456C39.9833 21.2971 39.2764 21.972 38.4249 21.9519Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.1265 25.8574L38.8821 26.603C38.5942 27.4072 37.7206 27.825 36.9213 27.5468C36.1147 27.2662 35.6895 26.3902 35.9774 25.586L36.1835 24.9574C36.4276 24.1388 37.2889 23.6845 38.105 23.9359C38.9139 24.1849 39.3706 25.0389 39.1265 25.8574Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.3858 31.4828C36.2336 31.7001 36.0765 31.9076 35.9194 32.1152C35.4047 32.7964 34.4396 32.9253 33.7657 32.4129C33.0868 31.8909 32.958 30.9258 33.4703 30.2519C33.6081 30.0785 33.7313 29.9003 33.8642 29.7172C34.3521 29.019 35.3121 28.8561 36.003 29.3417C36.7011 29.8296 36.8737 30.7847 36.3858 31.4828Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.028 35.9803C31.8221 36.1395 31.6112 36.2889 31.393 36.4359C30.69 36.9259 29.7355 36.7507 29.2528 36.0501C28.7701 35.3495 28.9454 34.395 29.6387 33.9099C29.8254 33.785 30.0048 33.6576 30.1792 33.5205C30.8578 33.0063 31.8242 33.145 32.3384 33.8235C32.8429 34.507 32.7066 35.4661 32.028 35.9803Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.5014 38.9122C26.2537 39.001 26.0084 39.0825 25.7582 39.1543C24.9421 39.3967 24.0884 38.9388 23.8363 38.1276C23.5938 37.3114 24.0541 36.4504 24.8703 36.208C25.084 36.1485 25.2929 36.0794 25.5041 36.0029C26.3055 35.7314 27.1785 36.1552 27.4574 36.9589C27.7363 37.7627 27.3052 38.6333 26.5014 38.9122Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.339 40.001C20.0787 40.0048 19.8184 40.0085 19.5533 40.0025C18.7018 39.9824 18.0342 39.2779 18.0543 38.4264C18.0647 37.5798 18.7716 36.9049 19.6231 36.925C19.8469 36.9336 20.0659 36.9325 20.2872 36.9241C21.1336 36.9102 21.8351 37.5854 21.854 38.4415C21.8679 39.288 21.1854 39.9871 20.339 40.001Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.0633 38.1055C15.8144 38.9143 14.9604 39.371 14.1418 39.127L13.3962 38.8826C12.5921 38.5947 12.1742 37.721 12.4524 36.9218C12.733 36.1152 13.6066 35.6973 14.4132 35.9779L15.0418 36.184C15.858 36.4354 16.3147 37.2893 16.0633 38.1055Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.6596 36.0014C10.1717 36.6995 9.21655 36.8721 8.51842 36.3842C8.30116 36.232 8.09361 36.0749 7.88607 35.9179C7.21213 35.4055 7.07597 34.438 7.58831 33.7641C8.11037 33.0852 9.07545 32.9564 9.74938 33.4687C9.92278 33.6065 10.0986 33.737 10.2841 33.8626C10.9822 34.3505 11.1524 35.3129 10.6596 36.0014Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.17724 32.3385C5.49377 32.843 4.53466 32.7067 4.02045 32.0281C3.86131 31.8222 3.71188 31.6113 3.56484 31.3931C3.08214 30.6925 3.2501 29.7356 3.9507 29.2529C4.65131 28.7702 5.60574 28.9455 6.09083 29.6388C6.21582 29.8255 6.34321 30.0049 6.4803 30.1793C6.99451 30.8579 6.85579 31.8243 6.17724 32.3385Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.03942 27.4575C2.23564 27.7364 1.36268 27.3126 1.0862 26.5015C0.997393 26.2538 0.915899 26.0086 0.844111 25.7584C0.601662 24.9422 1.0596 24.0886 1.87082 23.8364C2.68695 23.594 3.54793 24.0543 3.79038 24.8704C3.84982 25.0842 3.91897 25.293 3.99543 25.5043C4.267 26.3057 3.84321 27.1787 3.03942 27.4575Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.55718 21.8554C0.710724 21.8693 0.00922351 21.1941 -0.00232002 20.3404C-0.0060468 20.0801 -0.00977332 19.8198 -0.00379443 19.5547C0.0162966 18.7032 0.720849 18.0356 1.57234 18.0557C2.41653 18.0734 3.09382 18.773 3.07373 19.6245C3.07242 19.8507 3.0662 20.0673 3.0746 20.2886C3.08854 21.135 2.41335 21.8365 1.55718 21.8554Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.3625 6.09001C10.1758 6.215 9.99405 6.34969 9.82198 6.47947C9.14342 6.99368 8.17701 6.85497 7.6628 6.17641C7.1583 5.49294 7.29461 4.53384 7.97317 4.01963C8.17915 3.86049 8.39004 3.71105 8.60823 3.56401C9.30884 3.08132 10.2657 3.24927 10.7484 3.94988C11.2311 4.65048 11.0558 5.60491 10.3625 6.09001Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.02086 14.4142L3.81479 15.0429C3.57074 15.8614 2.70944 16.3157 1.89329 16.0644C1.08444 15.8154 0.627739 14.9614 0.871789 14.1429L1.1162 13.3973C1.40411 12.5931 2.27775 12.1752 3.07701 12.4534C3.88358 12.734 4.30877 13.6101 4.02086 14.4142Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.5293 9.74788C6.39151 9.92128 6.26594 10.1068 6.13545 10.2826C5.64755 10.9807 4.68511 11.1509 3.99428 10.6654C3.29614 10.1775 3.12594 9.21505 3.61385 8.51691C3.76602 8.29966 3.9231 8.09211 4.08019 7.88456C4.59253 7.21063 5.56001 7.07446 6.23155 7.59412C6.91279 8.10887 7.04165 9.07395 6.5293 9.74788Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26423">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="animate-spin">
        <svg
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3755_26445)">
            <path
              opacity="0.21"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.6676 4.92937C19.3897 5.00665 19.1182 5.09654 18.8436 5.19594C17.8018 5.54897 16.6669 4.99805 16.3044 3.95313C15.9418 2.9082 16.5023 1.77647 17.5472 1.41393C17.8692 1.29849 18.188 1.19254 18.5133 1.09922C19.5743 0.784035 20.684 1.37936 21.0118 2.43394C21.327 3.49491 20.7286 4.61419 19.6676 4.92937Z"
              fill="#465FFF"
            />
            <path
              opacity="0.25"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.4886 3.9974C26.1945 3.9957 25.913 3.98761 25.6253 3.99853C24.5249 4.01665 23.6129 3.1389 23.5884 2.02589C23.5703 0.925491 24.4575 0.0166559 25.5579 -0.00146568C25.8963 -0.00631059 26.2346 -0.0111551 26.5793 -0.00338251C27.6863 0.0227358 28.5542 0.938654 28.528 2.04559C28.5114 3.15565 27.5955 4.02352 26.4886 3.9974Z"
              fill="#465FFF"
            />
            <path
              opacity="0.28"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.8091 4.00137C35.4443 5.04991 34.3054 5.60265 33.26 5.22838L32.4428 4.96048C31.3787 4.64322 30.7881 3.52353 31.1148 2.46253C31.4385 1.41103 32.5487 0.817318 33.6097 1.14409C33.7743 1.18754 33.9359 1.24049 34.0974 1.29345C34.259 1.34641 34.4205 1.39936 34.5789 1.46182C35.6275 1.8266 36.1707 2.96233 35.8091 4.00137Z"
              fill="#465FFF"
            />
            <path
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M42.1385 8.10625C41.4598 8.98875 40.2052 9.15627 39.3291 8.49022C39.1037 8.31109 38.872 8.15096 38.634 7.97822C37.7264 7.34394 37.502 6.10227 38.1458 5.1978C38.7801 4.29023 40.0218 4.06585 40.9293 4.70013C41.2118 4.89795 41.4816 5.10216 41.7514 5.30637C42.6275 5.97242 42.8045 7.23014 42.1385 8.10625Z"
              fill="#465FFF"
            />
            <path
              opacity="0.33"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M46.8654 13.9711C45.9546 14.5986 44.7138 14.3708 44.0832 13.4695C43.9207 13.2268 43.7551 12.9936 43.5769 12.7668C42.9084 11.8847 43.0888 10.6284 43.9709 9.9599C44.8594 9.30405 46.1062 9.48126 46.7747 10.3634C46.9816 10.6312 47.1759 10.9053 47.367 11.189C47.9945 12.0998 47.7762 13.3436 46.8654 13.9711Z"
              fill="#465FFF"
            />
            <path
              opacity="0.38"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M49.5668 21.013C48.5058 21.3281 47.3865 20.7297 47.0713 19.6687C46.991 19.4003 46.9042 19.1193 46.8048 18.8447C46.4517 17.8029 47.0027 16.668 48.0476 16.3055C49.0925 15.943 50.2242 16.5034 50.5868 17.5483C50.7022 17.8703 50.8082 18.1892 50.9015 18.5144C51.2167 19.5754 50.6214 20.6852 49.5668 21.013Z"
              fill="#465FFF"
            />
            <path
              opacity="0.42"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M49.9504 28.5371C48.853 28.5141 47.9756 27.5951 48.0017 26.4882C48.0003 26.2036 48.0115 25.9126 48.0006 25.6249C47.9825 24.5245 48.8602 23.6125 49.9701 23.5975C51.0736 23.5699 51.9825 24.4571 52.0006 25.5575C52.0054 25.8959 52.0103 26.2342 52.0025 26.579C51.9764 27.6859 51.0573 28.5633 49.9504 28.5371Z"
              fill="#465FFF"
            />
            <path
              opacity="0.55"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50.8668 33.6144L50.5491 34.5837C50.1748 35.6291 49.0391 36.1723 48 35.8107C46.9515 35.4459 46.3987 34.3071 46.773 33.2616L47.0409 32.4444C47.3582 31.3803 48.4779 30.7897 49.5389 31.1165C50.5904 31.4401 51.1841 32.5503 50.8668 33.6144Z"
              fill="#465FFF"
            />
            <path
              opacity="0.65"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.2996 40.9277C47.1017 41.2102 46.8975 41.48 46.6933 41.7498C46.0242 42.6354 44.7695 42.8029 43.8934 42.1369C43.0109 41.4582 42.8434 40.2036 43.5095 39.3275C43.6886 39.1021 43.8487 38.8704 44.0215 38.6324C44.6557 37.7248 45.9038 37.513 46.8019 38.1442C47.7095 38.7785 47.9338 40.0201 47.2996 40.9277Z"
              fill="#465FFF"
            />
            <path
              opacity="0.7"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.6349 46.7744C41.3671 46.9813 41.093 47.1755 40.8093 47.3667C39.8954 48.0037 38.6546 47.7758 38.0271 46.8651C37.3996 45.9543 37.6275 44.7135 38.5288 44.0829C38.7715 43.9204 39.0046 43.7548 39.2314 43.5766C40.1136 42.9081 41.3699 43.0884 42.0384 43.9706C42.6942 44.8591 42.517 46.1059 41.6349 46.7744Z"
              fill="#465FFF"
            />
            <path
              opacity="0.8"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.4533 50.5861C34.1314 50.7016 33.8125 50.8075 33.4872 50.9008C32.4263 51.216 31.3165 50.6207 30.9887 49.5661C30.6735 48.5051 31.2719 47.3859 32.3329 47.0707C32.6108 46.9934 32.8823 46.9035 33.157 46.8041C34.1988 46.4511 35.3336 47.002 35.6962 48.0469C36.0587 49.0919 35.4983 50.2236 34.4533 50.5861Z"
              fill="#465FFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.4434 52.0014C26.1051 52.0063 25.7667 52.0111 25.422 52.0034C24.315 51.9772 23.4472 51.0613 23.4733 49.9544C23.4868 48.8538 24.4058 47.9765 25.5128 48.0026C25.8038 48.0138 26.0884 48.0124 26.3761 48.0014C27.4765 47.9833 28.3884 48.8611 28.4129 49.9741C28.431 51.0745 27.5438 51.9833 26.4434 52.0014Z"
              fill="#465FFF"
            />
            <path
              opacity="0.05"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.8847 49.5375C20.561 50.589 19.4508 51.1827 18.3867 50.8654L17.4175 50.5477C16.372 50.1734 15.8288 49.0377 16.1904 47.9986C16.5552 46.9501 17.691 46.4069 18.7395 46.7716L19.5567 47.0395C20.6177 47.3663 21.2114 48.4765 20.8847 49.5375Z"
              fill="#465FFF"
            />
            <path
              opacity="0.07"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.8555 46.8022C13.2212 47.7097 11.9796 47.9341 11.072 47.2998C10.7896 47.102 10.5197 46.8978 10.2499 46.6936C9.37382 46.0275 9.1968 44.7698 9.86286 43.8937C10.5415 43.0112 11.7961 42.8437 12.6722 43.5098C12.8977 43.6889 13.1262 43.8585 13.3673 44.0218C14.2749 44.656 14.4962 45.9072 13.8555 46.8022Z"
              fill="#465FFF"
            />
            <path
              opacity="0.09"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.02963 42.0401C7.14111 42.696 5.89428 42.5188 5.22581 41.6367C5.01892 41.3689 4.82466 41.0947 4.63351 40.8111C4.00601 39.9003 4.22434 38.6564 5.13513 38.0289C6.04592 37.4014 7.28668 37.6293 7.9173 38.5305C8.07979 38.7732 8.24539 39.0064 8.42361 39.2332C9.09208 40.1153 8.91175 41.3717 8.02963 42.0401Z"
              fill="#465FFF"
            />
            <path
              opacity="0.11"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.95281 35.6948C2.90789 36.0574 1.77304 35.5064 1.41362 34.452C1.29817 34.13 1.19223 33.8112 1.09891 33.4859C0.783723 32.4249 1.37904 31.3152 2.43363 30.9874C3.4946 30.6722 4.61387 31.2706 4.92906 32.3316C5.00633 32.6095 5.09623 32.881 5.19563 33.1556C5.54866 34.1974 4.99774 35.3323 3.95281 35.6948Z"
              fill="#465FFF"
            />
            <path
              opacity="0.13"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.02707 28.4118C0.926676 28.4299 0.0147249 27.5522 -0.000281568 26.4423C-0.00512651 26.1039 -0.00997093 25.7656 -0.00219836 25.4209C0.02392 24.3139 0.939838 23.4461 2.04678 23.4722C3.14422 23.4952 4.0247 24.4047 3.99858 25.5116C3.99688 25.8057 3.9888 26.0872 3.99971 26.375C4.01784 27.4753 3.14009 28.3873 2.02707 28.4118Z"
              fill="#465FFF"
            />
            <path
              opacity="0.19"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4677 7.91696C13.225 8.07945 12.9887 8.25455 12.7651 8.42326C11.8829 9.09174 10.6266 8.91141 9.95812 8.02928C9.30227 7.14077 9.47948 5.89394 10.3616 5.22546C10.6294 5.01858 10.9035 4.82432 11.1872 4.63317C12.098 4.00566 13.3419 4.224 13.9694 5.13479C14.5969 6.04558 14.369 7.28634 13.4677 7.91696Z"
              fill="#465FFF"
            />
            <path
              opacity="0.15"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.2279 18.7381L4.96 19.5553C4.64274 20.6194 3.52305 21.21 2.46205 20.8832C1.41055 20.5596 0.816842 19.4494 1.13411 18.3853L1.45184 17.416C1.82612 16.3706 2.96185 15.8274 4.00089 16.189C5.04943 16.5538 5.60218 17.6926 5.2279 18.7381Z"
              fill="#465FFF"
            />
            <path
              opacity="0.17"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.49082 12.6723C8.31169 12.8978 8.14845 13.1389 7.97882 13.3674C7.34455 14.275 6.09337 14.4963 5.1953 13.8651C4.28772 13.2308 4.06646 11.9797 4.70074 11.0721C4.89856 10.7897 5.10277 10.5198 5.30697 10.25C5.97303 9.37392 7.23075 9.1969 8.10375 9.87246C8.98936 10.5416 9.15688 11.7962 8.49082 12.6723Z"
              fill="#465FFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_3755_26445">
              <rect width="52" height="52" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
}
